import { Injectable } from '@angular/core';
import {PointerTracker} from "../binst/inputs/primitives/pointer-tracker";
import {User} from "../auth/primitives/user";
import {Store} from "@ngrx/store";
import * as networkSelectors from "../state/network/network.selector";
import {selectAuthIsReady} from "../state/auth/auth.selector";


export enum Readyables {
  network = "network",
  auth = "auth",
  // three = "three",
  // pixi = "pixi",
  // surface = "surface",
}

type ReadyCallback = (user:User) => any;


@Injectable({
  providedIn: 'root'
})
export class DoWhenReadyService {

  private readyState = {
    network: false,
    auth: false,
    three: false,
    pixi: false,
    surface: false,
  }

  private firstTimeCallbacks: {
    checks: Readyables[],
    callback: ReadyCallback,
    ran: boolean
  }[] = []
  everyTimeCallbacks: {
    checks: Readyables[],
    callback: ReadyCallback,
    isReady: boolean
  }[] = []

  private user: User = null

  constructor(
      private store: Store
  ) {
    this.store.select(networkSelectors.selectNetworkReady).subscribe(async (isReady) => {
      if (!isReady) return
      this.readyState.network = isReady
      this.testAgain()
    })
    this.store.select(selectAuthIsReady).subscribe(async ({authReady, user, isGuest}) => {
      this.readyState.auth = authReady
      this.user = user
      this.testAgain()
    })
  }

  private testAgain() {
    for (const firstTimeCallback of this.firstTimeCallbacks) {
      if (firstTimeCallback.ran) continue
      if (firstTimeCallback.checks.every(check => this.readyState[check])) {
        try {
          firstTimeCallback.callback(this.user)
        } finally {
          firstTimeCallback.ran = true
        }
      }
    }
    for (const everyTimeCallback of this.everyTimeCallbacks) {
      if (everyTimeCallback.checks.every(check => this.readyState[check])) {
        try {
          if (!everyTimeCallback.isReady) {
            everyTimeCallback.callback(this.user)
          }
        } finally {
        }
        everyTimeCallback.isReady = true
      } else {
        everyTimeCallback.isReady = false
      }
    }
  }

  public firstTime(context, readyables: Readyables[], callback: ReadyCallback) {
    const bound = callback.bind(this)
    if (readyables.every(check => this.readyState[check])) {
      bound(this.user)
      return;
    }
    this.firstTimeCallbacks.push({
      checks: readyables,
      callback: bound,
      ran: false
    })
  }

  public everyTime(context, readyables: Readyables[], callback: ReadyCallback) {
    const bound = callback.bind(context)
    const cb = {
        checks: readyables,
        callback: bound,
        isReady: false
    }
    if (readyables.every(check => this.readyState[check])) {
      cb.isReady = true
      bound(this.user).then()
    }
    this.everyTimeCallbacks.push(cb)
  }
}
